import React from "react";
import "./style.css";
import { HiOutlineArrowLeft } from "react-icons/hi";
//
export default function (props) {
  const {
    loading,
    loadingText,
    title,
    onSubmit,
    buttonText,
    children,
    width,
    className,
    hideButton,
    hideButtonOnPrint,
    buttonName,
    buttonClassName,
    childClassName,
    onBack,
  } = props;
  const getCarPriceHandler = () => {
    
    onSubmit();
  };
  return (
    <div
      className={`form_main_wrapper ${
        width === "fluid"
          ? "form_main_wrapper_width_fluid "
          : "form_main_wrapper_width"
      } cardShadow ${className || ""}`}
      style={{ margin: width === "fluid" ? "auto" : "1rem" }}
    >
      <div className="form_header">
        {title && <span className="form_header_text">{title}</span>}
      </div>
      <div className={childClassName}>{children}</div>
      <div className="dropdown_wrapper pi-evaluation__form-actions">
        {onBack ? (
          <button
            type="button"
            className="pi-evaluation__back-btn"
            onClick={onBack}
          >
            <HiOutlineArrowLeft size={18} aria-hidden />
            <span>Back</span>
          </button>
        ) : null}
        {hideButton ? null : (
          <button
            type="button"
            className={[
              "pi-evaluation__submit-btn",
              hideButtonOnPrint && "hideButtonOnPrint",
              buttonClassName,
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={!loading ? getCarPriceHandler : () => {}}
            name={buttonName || "CTAButton"}
            disabled={loading}
          >
            {loading ? loadingText || "Loading..." : buttonText || "Submit"}
          </button>
        )}
      </div>
    </div>
  );
}
